import { render } from "./SkuPreview.vue?vue&type=template&id=3ebd0444&scoped=true"
import script from "./SkuPreview.vue?vue&type=script&lang=js"
export * from "./SkuPreview.vue?vue&type=script&lang=js"

import "./SkuPreview.vue?vue&type=style&index=0&id=3ebd0444&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebd0444"]])

export default __exports__